import ekantaBhaktiImage from '../../images/Glories-of-Bhakti.jpeg';
import varnasramaDharmaImage from '../../images/Varṇāśrama.jpeg';
import bhagavataTattvaImage from '../../images/Śrīmad-Bhāgavatam.jpeg';
import angasOfBhaktiImage from '../../images/Limbs-of-Bhakti.jpeg';
import astrologyBhaktiImage from '../../images/Astrology.jpg';
import krsnaEnergiesImage from '../../images/Śakti-Tattva.jpeg';
import type { Theme, TopicContent, TopicMetadata } from './types';
import bhaktiIsSelfCausativeContent from './topic-content/sb-1-2-6-bhakti-is-self-causative';
import sb1919CommentaryContent from './topic-content/sb-1-9-19-commentary';
import whySrilaVyasadevWasDissatisfiedContent from './topic-content/why-srila-vyasadev-was-dissatisfied';
import sb1519TheIndestructibleTasteOfBhaktiContent from './topic-content/sb-1-5-19-the-indestructible-taste-of-bhakti';
import sb1635TheThreeGradesOfBhaktiContent from './topic-content/sb-1-6-35-the-three-grades-of-bhakti';
import whyAllProcessesWithoutBhaktiFailContent from './topic-content/sb-1-5-12-why-all-processes-without-bhakti-fail';
import bg1866CommentaryContent from './topic-content/bg-18-66-commentary';
import sb1517CommentaryContent from './topic-content/sb-1-5-17-commentary';
import sb11541CommentaryContent from './topic-content/sb-11-5-41-commentary';
import sb111EstablishingTheAbsoluteSourcePart1Content from './topic-content/sb-1-1-1-establishing-the-absolute-source-part-1';
import sb111SatyamParamAsKrsnaPart2Content from './topic-content/sb-1-1-1-satyam-param-as-krsna-part-2';
import sb111KrsnaAsTheSourceOfMadhuraRasaPart3Content from './topic-content/sb-1-1-1-krsna-as-the-source-of-madhura-rasa-part-3';
import sb111RadhaKrsnaAtTheSummitOfMadhuraRasaPart4Content from './topic-content/sb-1-1-1-radha-krsna-at-the-summit-of-madhura-rasa-part-4';
import sb111NirgunaBhaktiAsTheSupremeMeansPart5Content from './topic-content/sb-1-1-1-nirguna-bhakti-as-the-supreme-means-part-5';
import sb112CapturingKrsnaInTheHeartContent from './topic-content/sb-1-1-2-capturing-krsna-in-the-heart';
import sb113FruitFromSukasMouthContent from './topic-content/sb-1-1-3-fruit-from-sukas-mouth';
import sb2934MayaAndYogaMayaContent from './topic-content/sb-2-9-34-maya-and-yoga-maya';
import sb127BhaktiProducesVairagyaAndJnanaContent from './topic-content/sb-1-2-7-bhakti-produces-vairagya-and-jnana';
import sb128VarnasramaDharmaIsNotTheCauseOfPureBhaktiContent from './topic-content/sb-1-2-8-varnasrama-dharma-is-not-the-cause-of-pure-bhakti';
import sb1210TheLordPersonallyGivesTheDevoteesDistressAsMercyContent from './topic-content/sb-1-2-10-the-lord-personally-gives-the-devotees-distress-as-mercy';
import sb2111AmongAllAngasChantingTheLordsNameIsChiefContent from './topic-content/sb-2-1-11-among-all-angas-chanting-the-lords-name-is-chief';
import sb6291010HariNamaIsTheBestAtonementContent from './topic-content/sb-6-2-9-10-hari-nama-is-the-best-atonement';
import sb1213HariTosanamTheTrueMeasureOfAllPrescribedDutiesContent from './topic-content/sb-1-2-13-hari-tosanam-the-true-measure-of-all-prescribed-duties';
import sb1515TheGreatDisturbanceContent from './topic-content/sb-1-5-15-the-great-disturbance';
import sb121621TheFourteenStagesOfBhaktiContent from './topic-content/sb-1-2-16-21-the-fourteen-stages-of-bhakti';
import theForkThatDecidesEverythingContent from './topic-content/the-fork-that-decides-everything';
import astrologyEndeavorAndDestinyPart1Content from './topic-content/astrology-bhakti-endeavor-and-destiny-part-1';
import astrologySufferingNotPrarabdhaKarmaPart2Content from './topic-content/astrology-bhakti-suffering-not-prarabdha-karma-part-2';
import astrologyRoleOfAstrologyPart3Content from './topic-content/astrology-bhakti-role-of-astrology-part-3';
import astrologyBasisIsKarmaPart4Content from './topic-content/astrology-bhakti-basis-is-karma-part-4';
import astrologyPrabhupadaLettersPart5Content from './topic-content/astrology-bhakti-prabhupada-letters-part-5';
import bg713HowThreeModesAffectDifferentPractitionersContent from './topic-content/bg-7-13-how-three-modes-affect-different-practitioners';
import theEvolutionOfThe28ElementsContent from './topic-content/the-evolution-of-the-28-elements';

export const themes: Theme[] = [
    {
        id: 'ekanta-bhakti',
        slug: 'ekanta-bhakti',
        name: 'Ekānta Bhakti',
        description: 'Pure devotional service without any ulterior motive-the essence of spiritual life.',
        detailedDescription:
            'Ekānta Bhakti represents unmixed devotion to Kṛṣṇa, free from desires for liberation, mystic powers, or material benefits. These topics explore the nature, characteristics, and development of pure devotional service.',
        order: 1,
        imageSrc: ekantaBhaktiImage,
        relatedThemes: [],
    },
    {
        id: 'varnasrama-dharma',
        slug: 'varnasrama-dharma',
        name: 'Varṇāśrama Dharma',
        description:
            'The relationship between social/spiritual duties and pure devotion-when duties serve bhakti and when they become obstacles.',
        detailedDescription:
            'Varṇāśrama Dharma explores how the system of social and spiritual duties relates to pure devotional service. These topics reveal when varṇāśrama-dharma serves bhakti and when it becomes meaningless without devotion to the Lord.',
        order: 2,
        imageSrc: varnasramaDharmaImage,
        relatedThemes: [],
    },
    {
        id: 'bhagavata-tattva',
        slug: 'bhagavata-tattva',
        name: 'Bhāgavata-Tattva',
        description: 'The nature of the Supreme Lord, Śrīmad-Bhāgavatam, and the process by which He is directly realized.',
        detailedDescription:
            'Bhāgavata-Tattva explores the ontological and theological foundations of devotion through Śrīmad-Bhāgavatam: the nature of the Supreme Lord, the unique potency of Bhāgavata-śāstra, and the way bhakti grants direct realization beyond material and impersonal frameworks. This theme includes the five explanations of SB 1.1.1 and related foundational topics such as SB 1.1.2.',
        order: 3,
        imageSrc: bhagavataTattvaImage,
        relatedThemes: [],
    },
    {
        id: 'angas-of-bhakti',
        slug: 'angas-of-bhakti',
        name: 'Aṅgas of Bhakti',
        description:
            'The principal limbs of devotion and their hierarchy, with special focus on hearing, chanting, and remembrance.',
        detailedDescription:
            'Aṅgas of Bhakti explores the core practices of devotion as established in śāstra and explained by the ācāryas, including their relative prominence, universal applicability, and practical execution across different adhikāras.',
        order: 4,
        imageSrc: angasOfBhaktiImage,
        relatedThemes: [],
    },
    {
        id: 'astrology-bhakti',
        slug: 'astrology-bhakti',
        name: 'Astrology & Bhakti',
        description:
            'Endeavor, destiny, and mercy-what role astrology, karma, and the devatās actually have in a surrendered devotee\'s life.',
        detailedDescription:
            'Astrology & Bhakti explores endeavor, destiny, and the Lord\'s mercy as a single connected theme: how much a devotee should endeavor, why a devotee\'s suffering is not prārabdha-karma, why astrology and the devatās operate only within the domain of karma, and what Śrīla Prabhupāda himself taught-across decades of letters and conversations-about astrology\'s place in a devotee\'s life. A six-part series drawn from a Bhakti Saṅgha class by HG Balarāma Śakti Dāsa.',
        order: 5,
        imageSrc: astrologyBhaktiImage,
        relatedThemes: [],
    },
    {
        id: 'krsnas-energies',
        slug: 'krsnas-energies',
        name: "Kṛṣṇa's Energies",
        description:
            "The nature and function of Kṛṣṇa's three śaktis — aparā-prakṛti, jīva-śakti and kāla — as the philosophical foundation for pure devotional attachment.",
        detailedDescription:
            "Kṛṣṇa's Energies explores the aparā-prakṛti (material energy), parā-prakṛti (jīva-śakti) and kāla (time-energy) described in Bhagavad-gītā 7.4–7.6, with deep study from the Sāṅkhya teachings of Canto 2 and Canto 3 of Śrīmad-Bhāgavatam. Understanding the Lord's aiśvarya — His powers and energies — is, according to Śrīla Viśvanātha Cakravartī Ṭhākura, an integral stage in bhakti development: it must precede the realization of His mādhurya (sweetness). These topics lay that foundation.",
        order: 6,
        imageSrc: krsnaEnergiesImage,
        relatedThemes: [],
    },
];

export const ekantaBhaktiTopics: TopicMetadata[] = [
    {
        slug: 'sb-1-6-35-the-three-grades-of-bhakti',
        tags: ['pure-unmixed-bhakti', 'bhakti-surpasses-karma-jnana-yoga'],
        title: 'The Three Grades of Bhakti: Kevala, Prādhānya, and Guṇa-bhāva',
        shortDescription:
            'Why does aṣṭaṅga-yoga fail to pacify the mind? Śrīla Viśvanātha Cakravartī Ṭhākura reveals that only pure, unmixed devotion (kevala-bhakti) can fully satisfy the soul. This commentary defines the three grades of bhakti and explains why mixed processes yield only liberation, while pure devotion grants prema.',
        estimatedReadTime: 4,
        relatedTopics: [
            'why-srila-vyasadev-was-dissatisfied',
            'why-all-processes-without-bhakti-fail',
            'sb-1-5-17-commentary',
            'the-fork-that-decides-everything',
        ],
    },
    {
        slug: 'sb-1-5-19-the-indestructible-taste-of-bhakti',
        tags: ['no-karma-for-devotees', 'bhakti-is-unstoppable'],
        title: 'The Indestructible Taste of Bhakti',
        shortDescription:
            'A person who serves Mukunda never returns to saṁsāra. Śrīla Viśvanātha Cakravartī Ṭhākura explains how the taste of bhakti (rasa-graha) haunts the devotee. Even if they fall, the lasting impressions of the Lord\'s lotus feet bring them back to devotional service.',
        estimatedReadTime: 3,
    },
    {
        slug: 'bhakti-is-self-causative',
        tags: ['bhakti-is-causeless', 'bhakti-is-unstoppable'],
        title: 'Bhakti is self causative',
        shortDescription:
            'What is the final essence of all the scriptures? Śrīla Viśvanātha Cakravartī Ṭhākura reveals that bhakti is self-manifesting-it arises without cause and cannot be prevented by anything. This commentary explores how bhakti is the cause of bhakti itself.',
        estimatedReadTime: 6,
        relatedTopics: ['sb-1-2-7-bhakti-produces-vairagya-and-jnana'],
    },
    {
        slug: 'sb-1-9-19-commentary',
        tags: ['distress-as-mercy', 'prema'],
        title: 'From Anubhāva to Prema: When the Lord Gives Difficulties to Increase Devotion',
        shortDescription:
            'Śiva, Nārada and Kapila know Kṛṣṇa’s anubhāvas but not his intentions. Śrīla Viśvanātha Cakravartī Ṭhākura explains how knowers of rasa infer prema from these symptoms, and why the Lord sometimes gives devotees difficulties-not prārabdha-karma-to increase their devotion.',
        estimatedReadTime: 2,
    },
    {
        slug: 'sb-1-2-7-bhakti-produces-vairagya-and-jnana',
        tags: ['bhakti-is-causeless', 'pure-unmixed-bhakti'],
        title: 'Bhakti Alone Produces Vairāgya and Jñāna',
        shortDescription:
            'Śrīla Viśvanātha Cakravartī Ṭhākura explains that bhakti itself rapidly produces both detachment and realization of the Lord, and that this jñāna is ahaitukam-without any motive for impersonal liberation. Thus bhakti is both the means and the goal.',
        estimatedReadTime: 3,
        relatedTopics: ['bhakti-is-self-causative'],
    },
    {
        slug: 'sb-1-2-10-the-lord-personally-gives-the-devotees-distress-as-mercy',
        tags: ['distress-as-mercy', 'no-karma-for-devotees'],
        title: 'The Lord Personally Gives the Devotee\u2019s Distress as Mercy',
        shortDescription:
            'SB 1.2.10 establishes that sense pleasure and karma-results are not life\'s goal; tattva-jijñāsā is. Śrīla Viśvanātha Cakravartī Ṭhākura further distinguishes bhakti from karma-transformations and explains that a devotee\'s distress is understood as the Lord\'s personal mercy or as reaction to devotional offenses.',
        estimatedReadTime: 2,
        relatedTopics: [
            'bhakti-is-self-causative',
            'sb-1-2-7-bhakti-produces-vairagya-and-jnana',
            'astrology-bhakti-suffering-not-prarabdha-karma-part-2',
        ],
    },
    {
        slug: 'sb-1-2-16-21-the-fourteen-stages-of-bhakti',
        tags: ['stages-of-bhakti', 'pure-unmixed-bhakti', 'prema', 'bhakti-is-causeless'],
        title: 'The Fourteen Stages of Bhakti Development: From the Mercy of Devotees to Experiencing the Lord\'s Sweetness',
        shortDescription:
            'In his commentary on SB 1.2.16–21, Śrīla Viśvanātha Cakravartī Ṭhākura describes bhakti\'s complete development — from the first touch of a devotee\'s causeless mercy to directly experiencing Kṛṣṇa\'s sweetness. Following Nārada Muni\'s own journey, this teaching moves through all fourteen stages: satāṁ kṛpā, niṣṭhā, ruci, āsakti, rati, and premā, ending in harer mādhuryānubhava.',
        estimatedReadTime: 18,
        relatedTopics: [
            'bhakti-is-self-causative',
            'sb-1-2-7-bhakti-produces-vairagya-and-jnana',
            'sb-1-2-8-varnasrama-dharma-is-not-the-cause-of-pure-bhakti',
            'sb-1-2-13-hari-tosanam-the-true-measure-of-all-prescribed-duties',
            'the-fork-that-decides-everything',
        ],
    },
    {
        slug: 'the-fork-that-decides-everything',
        tags: ['bhakti-surpasses-karma-jnana-yoga', 'pure-unmixed-bhakti', 'prema'],
        title: 'The Fork That Decides Everything: How Karma, Jñāna, and Bhakti Mature into Prema',
        shortDescription:
            'Every path — karma, jñāna, or bhakti mixed with either — ends somewhere specific. Śrīla Viśvanātha Cakravartī Ṭhākura\'s commentary on Kapiladeva\'s teaching to Devahūti (SB 3.29) maps exactly which mixture produces which liberation, why the Four Kumāras stopped at śānta-bhakti instead of prema, and why every mixed path eventually either stalls or ripens into pure devotion.',
        estimatedReadTime: 10,
        relatedTopics: [
            'sb-1-6-35-the-three-grades-of-bhakti',
            'why-all-processes-without-bhakti-fail',
            'sb-1-2-16-21-the-fourteen-stages-of-bhakti',
        ],
    },
];

export const angasOfBhaktiTopics: TopicMetadata[] = [
    {
        slug: 'sb-2-1-11-among-all-angas-chanting-the-lords-name-is-chief',
        tags: ['holy-name'],
        title: "Among All Aṅgas, Chanting the Lord's Name Is Chief",
        shortDescription:
            'SB 2.1.11 establishes harer nāmānukīrtanam as the foremost aṅga of bhakti. Śrīla Viśvanātha Cakravartī Ṭhākura explains that chanting is universally prescribed-for unalloyed devotees, seekers of material elevation or liberation, and self-satisfied yogīs-while yielding results according to their approach.',
        estimatedReadTime: 2,
        relatedTopics: ['bhakti-is-self-causative', 'sb-1-2-7-bhakti-produces-vairagya-and-jnana', 'sb-6-2-9-10-hari-nama-is-the-best-atonement'],
    },
    {
        slug: 'sb-6-2-9-10-hari-nama-is-the-best-atonement',
        tags: ['holy-name', 'vaisnava-aparadha-atonement'],
        title: 'Hari-Nāma Is the Best Atonement — And the Lord Personally Remembers You',
        shortDescription:
            'Twelve-year vows of atonement destroy the effects of sin — but not the root. Chanting the Lord\'s name destroys the root. And it does something no prāyaścitta ever can: it causes the Lord himself to think, "This person belongs to me. I will always protect him." Śrīla Viśvanātha Cakravartī Ṭhākura\'s commentary on these two verses covers why Ajāmila was freed from his very first chanting, the danger of interpreting nāma\'s glories as exaggeration, Bhakti-devī\'s mercy to karmīs and jñānīs, and the three categories of Vaiṣṇavas and how each travels to the Lord.',
        estimatedReadTime: 23,
        relatedTopics: ['sb-2-1-11-among-all-angas-chanting-the-lords-name-is-chief', 'sb-1-5-17-commentary', 'bhakti-is-self-causative', 'sb-1-2-16-21-the-fourteen-stages-of-bhakti'],
    },
];

export const varnasramaDharmaTopics: TopicMetadata[] = [
    {
        slug: 'why-all-processes-without-bhakti-fail',
        tags: ['bhakti-surpasses-karma-jnana-yoga'],
        title: 'Why All Processes Without Bhakti Fail: The Hierarchy from Karma to Jñāna',
        shortDescription:
            'Even perfect jñāna without bhakti is not glorious. Śrīla Viśvanātha Cakravartī Ṭhākura reveals a devastating hierarchy: sakāma-karma fails, niṣkāma-karma without offering fails, and even liberated jñāna fails-all without bhakti. This commentary shows why even jīvan-muktas can fall.',
        estimatedReadTime: 3,
        relatedTopics: ['astrology-bhakti-endeavor-and-destiny-part-1', 'the-fork-that-decides-everything'],
    },
    {
        slug: 'bg-18-66-commentary',
        tags: ['surrender', 'no-karma-for-devotees'],
        title: 'The Crown Jewel of the Gītā: Varṇāśrama-Dharma Relinquished, One Refuge Only',
        shortDescription:
            `The Lord's command in Bhagavad-Gītā 18.66 is clear: "Give up all duties and surrender to Me." Śrīla Viśvanātha Cakravartī Ṭhākura explains what this means-not sannyāsa, not just giving up results, but complete surrender. This commentary reveals the six items of surrender, addresses Arjuna's fears, and shows how the Lord Himself frees the devotee from all sin.`,
        estimatedReadTime: 6,
        relatedTopics: ['sb-1-5-17-commentary', 'sb-11-5-41-commentary', 'astrology-bhakti-basis-is-karma-part-4'],
    },
    {
        slug: 'sb-1-5-17-commentary',
        tags: ['no-karma-for-devotees', 'bhakti-is-unstoppable'],
        title: 'No Sin, No Misfortune: The Complete Safety of Giving Up Varṇāśrama-Dharma for Bhakti',
        shortDescription:
            'Even perfect jñāna requires prior purification through karma, but bhakti is independently powerful. Śrīla Viśvanātha Cakravartī Ṭhākura reveals that giving up varṇāśrama-dharma for bhakti incurs no sin-even for beginners. Even if one falls, there is no misfortune, for bhakti impressions are indestructible. The sprout of bhakti will always bear fruit.',
        estimatedReadTime: 4,
        relatedTopics: ['bg-18-66-commentary', 'sb-11-5-41-commentary'],
    },
    {
        slug: 'sb-1-5-15-the-great-disturbance',
        tags: ['varnasrama-dharma-limits', 'vyasadeva-and-bhagavatam'],
        title: 'The Great Disturbance: Why Teaching Material Dharma Backfires',
        shortDescription:
            'Vyāsadeva meant well. He wrote the Mahābhārata to attract materialistic people to the Lord by first speaking of material happiness. Nārada Muni exposes the fatal flaw in this strategy: people become so attached to the "bait" that they ignore the hook of pure devotion.',
        estimatedReadTime: 2,
        relatedTopics: ['bg-18-66-commentary', 'sb-1-5-17-commentary'],
    },
    {
        slug: 'sb-11-5-41-commentary',
        tags: ['surrender', 'no-karma-for-devotees'],
        title: 'Freedom from All Obligations: Taking Shelter of Mukunda Dissolves All Varṇāśrama-Dharma Duties',
        shortDescription:
            'One who takes shelter of Mukunda is freed from all obligations-to devatās, sages, family, and Pitṛs. Śrīla Viśvanātha Cakravartī Ṭhākura explains that bhakti is devoid of troubles from daily and occasional duties. Like the servant of an emperor cannot serve a provincial ruler, the devotee of Mukunda has no obligations to anyone. Worshipping Viṣṇu satisfies all.',
        estimatedReadTime: 2,
        relatedTopics: ['bg-18-66-commentary', 'sb-1-5-17-commentary', 'astrology-bhakti-role-of-astrology-part-3'],
    },
    {
        slug: 'sb-1-2-8-varnasrama-dharma-is-not-the-cause-of-pure-bhakti',
        tags: ['bhakti-is-causeless', 'bhakti-surpasses-karma-jnana-yoga', 'varnasrama-dharma-limits'],
        title: 'Varṇāśrama-Dharma Is Not the Cause of Pure Bhakti',
        shortDescription:
            'SB 1.2.8 establishes that even properly performed varṇāśrama-dharma is useless if it does not awaken attraction to the Lord\u2019s topics. Śrīla Viśvanātha Cakravartī Ṭhākura clarifies that karma may support jñāna, but pure bhakti is independent and self-manifesting.',
        estimatedReadTime: 5,
        relatedTopics: ['sb-1-5-17-commentary', 'sb-11-5-41-commentary', 'sb-1-2-16-21-the-fourteen-stages-of-bhakti'],
    },
    {
        slug: 'sb-1-2-13-hari-tosanam-the-true-measure-of-all-prescribed-duties',
        tags: ['no-karma-for-devotees', 'bhakti-surpasses-karma-jnana-yoga', 'varnasrama-dharma-limits', 'pure-unmixed-bhakti'],
        title: 'Hari-Toṣaṇam: The True Measure of All Prescribed Duties',
        shortDescription:
            'SB 1.2.13 establishes that the perfection of all varṇāśrama duties is solely to please Hari. Śrīla Viśvanātha Cakravartī Ṭhākura shows that bhakti independently grants the fruits sought through karma, jñāna, and yoga, and nullifies the fear that neglect of karma necessarily incurs sin for the devotee.',
        estimatedReadTime: 6,
        relatedTopics: [
            'sb-1-2-8-varnasrama-dharma-is-not-the-cause-of-pure-bhakti',
            'sb-1-5-17-commentary',
            'sb-11-5-41-commentary',
            'sb-1-2-16-21-the-fourteen-stages-of-bhakti',
        ],
    },
];

export const bhagavataTattvaTopics: TopicMetadata[] = [
    {
        slug: 'the-evolution-of-the-28-elements',
        tags: ['material-nature', 'creation'],
        title: 'The Evolution of the 28 Elements',
        shortDescription:
            'A visual mapping of Lord Kapila\'s ontology from Śrīmad-Bhāgavatam, tracing how spirit descends into matter through the 28 elements of creation.',
        estimatedReadTime: 5,
    },
    {
        slug: 'why-srila-vyasadev-was-dissatisfied',
        tags: ['krishna-as-supreme-truth', 'glories-of-bhagavatam', 'vyasadeva-and-bhagavatam'],
        title: 'Why Srila Vyāsadev was Dissatisfied?',
        shortDescription:
            'Nārada Muni points out the fundamental flaw in Vyāsadeva’s previous works. Although he compiled the Vedānta-sūtras and the Purāṇas, he only described Kṛṣṇa as a means to mokṣa, not as the supreme goal, leaving his own heart dissatisfied.',
        estimatedReadTime: 3,
    },
    {
        slug: 'sb-1-1-1-establishing-the-absolute-source-part-1',
        tags: ['krishna-as-supreme-truth'],
        title: 'Janmādy Asya Yataḥ: Establishing the Absolute Source — First Explanation',
        shortDescription:
            'SB 1.1.1\'s first explanation: Śrīla Viśvanātha Cakravartī Ṭhākura establishes the Supreme Lord as the conscious, independent, and complete cause of creation, maintenance, and dissolution, while affirming the eternality of His transcendental form beyond material reasoning.',
        estimatedReadTime: 15,
        series: {
            name: 'SB 1.1.1 — Five Explanations by Śrīla Viśvanātha Cakravartī Ṭhākura',
            part: 1,
            totalParts: 5,
        },
        relatedTopics: [
            'sb-1-1-1-satyam-param-as-krsna-part-2',
            'sb-1-1-1-krsna-as-the-source-of-madhura-rasa-part-3',
            'sb-1-1-1-radha-krsna-at-the-summit-of-madhura-rasa-part-4',
            'sb-1-1-1-nirguna-bhakti-as-the-supreme-means-part-5',
        ],
    },
    {
        slug: 'sb-1-1-1-satyam-param-as-krsna-part-2',
        tags: ['krishna-as-supreme-truth'],
        title: 'Satyam Paraṁ as Kṛṣṇa: Second Explanation',
        shortDescription:
            'Satyaṁ paraṁ dhīmahi — Śrīla Viśvanātha Cakravartī Ṭhākura\'s second explanation of SB 1.1.1 reveals this as direct meditation on Kṛṣṇa, establishing His self-revealed form, His Mathurā and Vraja pastimes, and His supreme independence known only through His mercy.',
        estimatedReadTime: 8,
        series: {
            name: 'SB 1.1.1 — Five Explanations by Śrīla Viśvanātha Cakravartī Ṭhākura',
            part: 2,
            totalParts: 5,
        },
        relatedTopics: [
            'sb-1-1-1-establishing-the-absolute-source-part-1',
            'sb-1-1-1-krsna-as-the-source-of-madhura-rasa-part-3',
            'sb-1-1-1-radha-krsna-at-the-summit-of-madhura-rasa-part-4',
            'sb-1-1-1-nirguna-bhakti-as-the-supreme-means-part-5',
        ],
    },
    {
        slug: 'sb-1-1-1-krsna-as-the-source-of-madhura-rasa-part-3',
        tags: ['rasa-tattva'],
        title: 'Kṛṣṇa as the Source of Madhura-Rasa: Third Explanation',
        shortDescription:
            'Why is Kṛṣṇa the sole source of madhura-rasa? Śrīla Viśvanātha Cakravartī Ṭhākura\'s third explanation of SB 1.1.1 shows union and separation as its secret dynamics, and why true rasa, poetic meaning, and aesthetic fulfillment culminate only in Him.',
        estimatedReadTime: 4,
        series: {
            name: 'SB 1.1.1 — Five Explanations by Śrīla Viśvanātha Cakravartī Ṭhākura',
            part: 3,
            totalParts: 5,
        },
        relatedTopics: [
            'sb-1-1-1-establishing-the-absolute-source-part-1',
            'sb-1-1-1-satyam-param-as-krsna-part-2',
            'sb-1-1-1-radha-krsna-at-the-summit-of-madhura-rasa-part-4',
            'sb-1-1-1-nirguna-bhakti-as-the-supreme-means-part-5',
        ],
    },
    {
        slug: 'sb-1-1-1-radha-krsna-at-the-summit-of-madhura-rasa-part-4',
        tags: ['rasa-tattva'],
        title: 'Rādhā-Kṛṣṇa at the Summit of Madhura-Rasa: Fourth Explanation',
        shortDescription:
            'Rādhā-Kṛṣṇa stand at the very summit of madhura-rasa. This fourth explanation of SB 1.1.1 shows Kṛṣṇa’s exclusive following of Rādhā, the dhīra-lalita principle, and the Bhāgavatam as the heart-transmitted revelation of this highest sweetness.',
        estimatedReadTime: 5,
        series: {
            name: 'SB 1.1.1 — Five Explanations by Śrīla Viśvanātha Cakravartī Ṭhākura',
            part: 4,
            totalParts: 5,
        },
        relatedTopics: [
            'sb-1-1-1-establishing-the-absolute-source-part-1',
            'sb-1-1-1-satyam-param-as-krsna-part-2',
            'sb-1-1-1-krsna-as-the-source-of-madhura-rasa-part-3',
            'sb-1-1-1-nirguna-bhakti-as-the-supreme-means-part-5',
        ],
    },
    {
        slug: 'sb-1-1-1-nirguna-bhakti-as-the-supreme-means-part-5',
        tags: ['bhakti-is-causeless', 'bhakti-surpasses-karma-jnana-yoga', 'pure-unmixed-bhakti'],
        title: 'Nirguṇa Bhakti as the Supreme Means: Fifth Explanation',
        shortDescription:
            'Karma, jñāna, and yoga find completion only through association with bhakti. Śrīla Viśvanātha Cakravartī Ṭhākura\'s fifth and final explanation of SB 1.1.1 establishes nirguṇa bhakti as the independent, supreme means by which Bhagavān is realized directly.',
        estimatedReadTime: 12,
        series: {
            name: 'SB 1.1.1 — Five Explanations by Śrīla Viśvanātha Cakravartī Ṭhākura',
            part: 5,
            totalParts: 5,
        },
        relatedTopics: [
            'sb-1-1-1-establishing-the-absolute-source-part-1',
            'sb-1-1-1-satyam-param-as-krsna-part-2',
            'sb-1-1-1-krsna-as-the-source-of-madhura-rasa-part-3',
            'sb-1-1-1-radha-krsna-at-the-summit-of-madhura-rasa-part-4',
        ],
    },
    {
        slug: 'sb-1-1-2-capturing-krsna-in-the-heart',
        tags: ['glories-of-bhagavatam', 'prema'],
        title: 'The Power of Bhāgavatam: Capturing Kṛṣṇa in the Heart',
        shortDescription:
            'Śrīmad-Bhāgavatam alone reveals the permanent spiritual reality, rejects all cheating dharmas, and captures the Supreme Lord in the heart of sincere hearers—immediately for the qualified and progressively for all who approach hearing.',
        estimatedReadTime: 8,
        relatedTopics: ['sb-1-1-3-fruit-from-sukas-mouth'],
    },
    {
        slug: 'sb-1-1-3-fruit-from-sukas-mouth',
        tags: ['rasa-tattva', 'glories-of-bhagavatam'],
        title: 'The Fruit from Śuka’s Mouth: Drinking the Rasa of Bhāgavatam',
        shortDescription:
            'Śrīla Viśvanātha Cakravartī Ṭhākura reveals SB 1.1.3 as the theology of Bhāgavata-rasa: the ripened fruit of the Vedic tree descending through guru-paramparā, to be repeatedly relished by rasika devotees, culminating in Kṛṣṇa as rasa and the ultimate foundation of brahman.',
        estimatedReadTime: 11,
        relatedTopics: ['sb-1-1-2-capturing-krsna-in-the-heart'],
    },
    {
        slug: 'sb-2-9-34-maya-and-yoga-maya',
        tags: ['maya-and-yoga-maya', 'krishna-as-supreme-truth'],
        title: 'Yathābhāso Yathā Tamaḥ: One Analogy, Two Energies — Māyā and Yoga-māyā',
        shortDescription:
            'The Lord answers Brahmā\'s question about māyā and yoga-māyā with a single verse carrying two meanings. One reading defines vidyā and avidyā—why jñāna alone reaches only impersonal Brahman, and only bhakti reveals Bhagavān. The other reveals yoga-māyā\'s reveal-and-conceal logic through six pastimes: Yaśodā, Arjuna, Brahmā, the Dāmodara-līlā, and more.',
        estimatedReadTime: 15,
        relatedTopics: [
            'sb-1-1-1-establishing-the-absolute-source-part-1',
            'sb-1-1-1-nirguna-bhakti-as-the-supreme-means-part-5',
        ],
    },
];

export const astrologyBhaktiTopics: TopicMetadata[] = [
    {
        slug: 'astrology-bhakti-endeavor-and-destiny-part-1',
        tags: ['astrology-and-destiny', 'bhakti-surpasses-karma-jnana-yoga'],
        title: 'Endeavor and Destiny: What Should a Devotee Strive For? — Part 1',
        shortDescription:
            'Śrīmad-Bhāgavatam 1.5.18 says happiness and distress come whether or not we endeavor for them. Does that mean endeavor is pointless? Bhagavad-gītā 18.14\'s five factors of action explain why every material endeavor is a gamble-and why, in bhakti alone, endeavor itself is the result.',
        estimatedReadTime: 7,
        series: {
            name: 'Astrology & Bhakti',
            part: 1,
            totalParts: 5,
        },
        relatedTopics: [
            'astrology-bhakti-suffering-not-prarabdha-karma-part-2',
            'astrology-bhakti-role-of-astrology-part-3',
            'why-all-processes-without-bhakti-fail',
        ],
    },
    {
        slug: 'astrology-bhakti-suffering-not-prarabdha-karma-part-2',
        tags: ['distress-as-mercy', 'no-karma-for-devotees'],
        title: 'Why a Devotee\'s Suffering Is Not Prārabdha-Karma — Part 2',
        shortDescription:
            'Drawing on Śrīla Viśvanātha Cakravartī Ṭhākura\'s Madhurya-kadambini, this part shows exactly what distinguishes suffering given directly by the Lord from ordinary karmic suffering-and why, for a surrendered devotee, the difference is like being beaten by an enemy versus disciplined by one\'s own mother.',
        estimatedReadTime: 9,
        series: {
            name: 'Astrology & Bhakti',
            part: 2,
            totalParts: 5,
        },
        relatedTopics: [
            'astrology-bhakti-endeavor-and-destiny-part-1',
            'astrology-bhakti-role-of-astrology-part-3',
            'sb-1-2-10-the-lord-personally-gives-the-devotees-distress-as-mercy',
        ],
    },
    {
        slug: 'astrology-bhakti-role-of-astrology-part-3',
        tags: ['astrology-and-destiny', 'no-karma-for-devotees'],
        title: 'The Role of Astrology in a Devotee\'s Life — Part 3',
        shortDescription:
            'SB 11.2.6 calls the devatās "attendants of karma"-a shadow that can only move exactly as the body moves. HG Balarāma Śakti Dāsa explains why astrology and the devatās operate entirely within the domain of karma, and why a surrendered devotee, whose karma is burned to ash, is simply beyond their jurisdiction.',
        estimatedReadTime: 8,
        series: {
            name: 'Astrology & Bhakti',
            part: 3,
            totalParts: 5,
        },
        relatedTopics: [
            'astrology-bhakti-suffering-not-prarabdha-karma-part-2',
            'astrology-bhakti-basis-is-karma-part-4',
            'sb-11-5-41-commentary',
        ],
    },
    {
        slug: 'astrology-bhakti-basis-is-karma-part-4',
        tags: ['astrology-and-destiny', 'surrender'],
        title: 'The Basis of Astrology Is Karma — And Kṛṣṇa\'s Personal Intervention — Part 4',
        shortDescription:
            '"Doesn\'t astrology work for devotees?" His Holiness Rādhānātha Swāmī Mahārāja\'s answer-and the story of Śrīla Prabhupāda\'s 1966 heart attack-show that a devotee\'s destiny is not read by any chart, because Kṛṣṇa personally takes over the moment genuine surrender arises.',
        estimatedReadTime: 8,
        series: {
            name: 'Astrology & Bhakti',
            part: 4,
            totalParts: 5,
        },
        relatedTopics: [
            'astrology-bhakti-role-of-astrology-part-3',
            'astrology-bhakti-prabhupada-letters-part-5',
            'bg-18-66-commentary',
        ],
    },
    {
        slug: 'astrology-bhakti-prabhupada-letters-part-5',
        tags: ['astrology-and-destiny'],
        title: 'Śrīla Prabhupāda on Astrology: Letters, Conversations & Memories — Part 5',
        shortDescription:
            '"Astrology is meant for the karmīs. We have no interest in such things." Across a decade of letters, room conversations, and memories shared by his own disciples, Śrīla Prabhupāda\'s position on astrology never wavers-collected here in his own words.',
        estimatedReadTime: 13,
        series: {
            name: 'Astrology & Bhakti',
            part: 5,
            totalParts: 5,
        },
        relatedTopics: ['astrology-bhakti-basis-is-karma-part-4', 'astrology-bhakti-role-of-astrology-part-3'],
    },
];

export const krsnaEnergiesTopics: TopicMetadata[] = [
    {
        slug: 'bg-7-13-how-three-modes-affect-different-practitioners',
        tags: ['modes-of-nature'],
        title: 'How Do the Three Modes Affect Different Practitioners?',
        shortDescription:
            'Bhagavad-gītā 7.13 reveals a hidden danger: the three modes bewilder everyone, but not in the same way. Śrīla Baladeva Vidyābhāṣuṇa teaches that modes affect different people based on their faith type (pure, contaminated, or sentimental) and their conditioned nature (svabhāva). Viśvanātha Cakravartī Ṭhākura identifies five specific disturbances arising from the modes in spiritual practice, and shows how to transcend them through pure association and bhakti.',
        estimatedReadTime: 12,
        relatedTopics: [
            'sb-2-9-34-maya-and-yoga-maya',
            'sb-1-1-1-nirguna-bhakti-as-the-supreme-means-part-5',
            'the-fork-that-decides-everything',
        ],
    },
];

export const topicContentBySlug: Record<string, TopicContent> = {
    'the-evolution-of-the-28-elements': theEvolutionOfThe28ElementsContent,
    'sb-1-6-35-the-three-grades-of-bhakti': sb1635TheThreeGradesOfBhaktiContent,
    'why-srila-vyasadev-was-dissatisfied': whySrilaVyasadevWasDissatisfiedContent,
    'sb-1-5-19-the-indestructible-taste-of-bhakti': sb1519TheIndestructibleTasteOfBhaktiContent,
    'bhakti-is-self-causative': bhaktiIsSelfCausativeContent,
    'sb-1-9-19-commentary': sb1919CommentaryContent,
    'why-all-processes-without-bhakti-fail': whyAllProcessesWithoutBhaktiFailContent,
    'bg-18-66-commentary': bg1866CommentaryContent,
    'sb-1-5-17-commentary': sb1517CommentaryContent,
    'sb-11-5-41-commentary': sb11541CommentaryContent,
    'sb-1-1-1-establishing-the-absolute-source-part-1': sb111EstablishingTheAbsoluteSourcePart1Content,
    'sb-1-1-1-satyam-param-as-krsna-part-2': sb111SatyamParamAsKrsnaPart2Content,
    'sb-1-1-1-krsna-as-the-source-of-madhura-rasa-part-3': sb111KrsnaAsTheSourceOfMadhuraRasaPart3Content,
    'sb-1-1-1-radha-krsna-at-the-summit-of-madhura-rasa-part-4': sb111RadhaKrsnaAtTheSummitOfMadhuraRasaPart4Content,
    'sb-1-1-1-nirguna-bhakti-as-the-supreme-means-part-5': sb111NirgunaBhaktiAsTheSupremeMeansPart5Content,
    'sb-1-1-2-capturing-krsna-in-the-heart': sb112CapturingKrsnaInTheHeartContent,
    'sb-1-1-3-fruit-from-sukas-mouth': sb113FruitFromSukasMouthContent,
    'sb-2-9-34-maya-and-yoga-maya': sb2934MayaAndYogaMayaContent,
    'sb-1-2-7-bhakti-produces-vairagya-and-jnana': sb127BhaktiProducesVairagyaAndJnanaContent,
    'sb-1-2-8-varnasrama-dharma-is-not-the-cause-of-pure-bhakti':
    sb128VarnasramaDharmaIsNotTheCauseOfPureBhaktiContent,
    'sb-1-2-10-the-lord-personally-gives-the-devotees-distress-as-mercy':
    sb1210TheLordPersonallyGivesTheDevoteesDistressAsMercyContent,
    'sb-1-5-15-the-great-disturbance': sb1515TheGreatDisturbanceContent,
    'sb-2-1-11-among-all-angas-chanting-the-lords-name-is-chief':
    sb2111AmongAllAngasChantingTheLordsNameIsChiefContent,
    'sb-6-2-9-10-hari-nama-is-the-best-atonement': sb6291010HariNamaIsTheBestAtonementContent,
    'sb-1-2-13-hari-tosanam-the-true-measure-of-all-prescribed-duties':
    sb1213HariTosanamTheTrueMeasureOfAllPrescribedDutiesContent,
    'sb-1-2-16-21-the-fourteen-stages-of-bhakti': sb121621TheFourteenStagesOfBhaktiContent,
    'the-fork-that-decides-everything': theForkThatDecidesEverythingContent,
    'astrology-bhakti-endeavor-and-destiny-part-1': astrologyEndeavorAndDestinyPart1Content,
    'astrology-bhakti-suffering-not-prarabdha-karma-part-2': astrologySufferingNotPrarabdhaKarmaPart2Content,
    'astrology-bhakti-role-of-astrology-part-3': astrologyRoleOfAstrologyPart3Content,
    'astrology-bhakti-basis-is-karma-part-4': astrologyBasisIsKarmaPart4Content,
    'astrology-bhakti-prabhupada-letters-part-5': astrologyPrabhupadaLettersPart5Content,
    'bg-7-13-how-three-modes-affect-different-practitioners': bg713HowThreeModesAffectDifferentPractitionersContent,
};

export function getTopicsByTheme(themeId: string): TopicMetadata[] {
    if (themeId === 'ekanta-bhakti') return ekantaBhaktiTopics;
    if (themeId === 'varnasrama-dharma') return varnasramaDharmaTopics;
    if (themeId === 'bhagavata-tattva' || themeId === 'bhagavat-tattva') return bhagavataTattvaTopics;
    if (themeId === 'angas-of-bhakti') return angasOfBhaktiTopics;
    if (themeId === 'astrology-bhakti') return astrologyBhaktiTopics;
    if (themeId === 'krsnas-energies') return krsnaEnergiesTopics;
    return [];
}

export function getTopicBySlug(slug: string): TopicMetadata | undefined {
    return (
        ekantaBhaktiTopics.find((topic) => topic.slug === slug) ||
        varnasramaDharmaTopics.find((topic) => topic.slug === slug) ||
        bhagavataTattvaTopics.find((topic) => topic.slug === slug) ||
        angasOfBhaktiTopics.find((topic) => topic.slug === slug) ||
        astrologyBhaktiTopics.find((topic) => topic.slug === slug) ||
        krsnaEnergiesTopics.find((topic) => topic.slug === slug)
    );
}

export function getThemeForTopic(slug: string): Theme | undefined {
    return themes.find((theme) => getTopicsByTheme(theme.id).some((topic) => topic.slug === slug));
}

export function getRelatedTopics(topicSlug: string): TopicMetadata[] {
    const topic = getTopicBySlug(topicSlug);
    if (!topic?.relatedTopics?.length) {
        return [];
    }

    return topic.relatedTopics
                .map((slug) => getTopicBySlug(slug))
                .filter((candidate): candidate is TopicMetadata => candidate !== undefined);
}

export function getAllThemesWithCounts() {
    return themes.map((theme) => ({
        ...theme,
        topicCount: getTopicsByTheme(theme.id).length,
    }));
}
